jQuery(function ($) {
  initialiseMenuForMobile();
  $(".menu-toggle").on("click", function () {
    var $target = $($(this).attr("aria-controls"));

    if ($target.hasClass("active")) {
      $("body").removeClass("menu-open");
      hideMenu($target);
    } else {
      $("body").addClass("menu-open");
      showMenu($target);
    }
    $(this).toggleClass("active");
    $target.toggleClass("active");
  });

  var isMobile = window.matchMedia("only screen and (max-width: 767px)");

  $(".menu-item-has-children > a").on("click", function (e) {
    if (isMobile.matches) {
      e.preventDefault();
      var $subMenu = $(this).next(".sub-menu");

      if ($subMenu.hasClass("active")) {
        hideMenu($subMenu);
      } else {
        showSubMenu($subMenu);
      }
      $(this).toggleClass("active");
      $subMenu.toggleClass("active");
    }
  });

  function showMenu($target) {
    var targetHeight = window.innerHeight;
    $target.css("height", targetHeight - ($target.offset().top - $(window).scrollTop()));
  }

  function hideMenu($target) {
    $target.css("height", 0);
  }

  function showSubMenu($target) {
    var targetHeight = $target.prop("scrollHeight");
    $target.css("height", targetHeight);
  }

  function initialiseMenuForMobile() {
    $("#site-navigation__menu").find(".menu-item.menu-item-has-children").each(function () {
      var $subMenu = $(this).find(".sub-menu");
      var $link = $(this).children("a");

      var newNewMenuItem = $("<li class='menu-item menu-item-mobile-only'>");
      newNewMenuItem.append($link.clone());
      $subMenu.prepend(newNewMenuItem);
    });
  }

  //
  //  Sticky header
  // ---------------------------------------
  function debounce(fn, delay) {
    let timeoutId;
    return function(...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  var $header = $('.site-header');
  if (!$header.length) return;

  if ($header.data('sticky-header-on') !== true && $header.data('sticky-header-on') !== 'true') {
    return; // Sticky off
  }

  var offset = parseInt($header.data('sticky-scroll-offset'), 10);
  if (isNaN(offset)) offset = 10;

  var isStuck = false;

  function checkSticky() {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > offset) {
      if (!isStuck) {
        $header.addClass('site-header--stuck');
        isStuck = true;
      }
    } else {
      if (isStuck) {
        $header.removeClass('site-header--stuck');
        isStuck = false;
      }
    }
  }

  $(window).on('scroll', debounce(checkSticky, 10));

  //
  //  Header Search
  // ---------------------------------------
  document.querySelectorAll('[aria-controls="#site-search"]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.getElementById('search-form').showModal();
    });
  });

  document.querySelectorAll('#search-form [data-form-popup-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.getElementById('search-form').close();
    });
  });
});
